import React, { Component } from "react";
import Modal from "react-modal";
import "../../common.css";
import { MdClose } from "react-icons/md";
import config from "@config";
import errorFunctions from "@store/errorFunctions";
import SelectOption from "@components/Select/SelectOption";
// import { postNewStaffFunction } from "./api";

Modal.setAppElement("body");

export default class InventoryAdd extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      id: "",
      material_number: this.props.inventoryData?.material_number || "",
      device_name: this.props.inventoryData?.device_name || "",
      device: this.props.inventoryData?.device
        ? {
            value: this.props.inventoryData.device,
            label: this.props.inventoryData.device_name,
          }
        : null,
      spare_part_name: this.props.inventoryData?.spare_part_name || "",
      // quantity: this.props.inventoryData?.quantity || "0",
      part_used: this.props.inventoryData?.part_used || 0,
      // selectedBrand: this.props.inventoryData?.brand
      //   ? {
      //       value: this.props.inventoryData.brand,
      //       label: this.props.inventoryData.brand_name,
      //     }
      //   : null,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    let payload = {
      material_number: this.state.material_number,
      device: this.state.device?.value || null,
      spare_part_name: this.state.spare_part_name,
      // quantity: parseInt(this.state.quantity),
    };

    const url = this.props.isEdit
      ? config.backendServer +
        `inventories/` +
        this.props.inventoryData.inventory_id +
        "/"
      : config.backendServer + `inventories/`;

    this.props
      .protectedFetch(
        url,
        this.props.isEdit ? "PUT" : "POST",
        payload,
        errorFunctions.checkResponseThenJson
      )
      .then(() => {
        //mini reload
        this.setState({
          showAssignModal: false,
          material_number: "",
          device: 0,
          spare_part_name: "",
          quantity: 0,
        });
        this.props.reloadInventory();
        this.props.handleCloseModal();
      })
      .catch((err) => {
        alert(err);
      });
  };
  handleRole = (e) => {
    this.setState({ currentRole: e.target.value });
  };
  handleChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };
  render() {
    if (this.state.redirect) {
      // Redirect only occurs when its a super user
      // return <Redirect to={"/manage-staff"} />;
    }
    
    return (
      <div className={"card"} style={{ width: "100%" }}>
        <button
          onClick={() => this.props.handleCloseModal()}
          className={"confirm-modal-close"}
        >
          <MdClose />
        </button>
        <h4 className={"card-header"}>{`${
          this.props.isEdit ? "Edit" : "Add"
        } Inventory`}</h4>
        <form onSubmit={this.handleSubmit}>
          <div className="card-body">
            <div className={"single-warranty-details-item  mb-3"}>
              <label
                className={"single-warranty-details-label required"}
                htmlFor="maerial_number"
              >
                Material Number<span></span>
              </label>
              <input
                type="text"
                id="material_number"
                required={true}
                className="form-control"
                value={this.state.material_number}
                onChange={this.handleChange}
              />
            </div>
            <div className={"single-warranty-details-item mb-3"}>
              <label
                className={"single-warranty-details-label required"}
                htmlFor="device"
              >
                Model<span></span>
                {this.state.device?.value || ""}
              </label>

              <SelectOption
                apiEndpoint={config.backendServer + "device/dropdown/"}
                // for future development multiple brand device selection
                // additionalParams={{
                //   brandId: this.props.selectedbrandID,
                // }}
                placeholder="Select Device"
                value={this.state.device}
                onChange={(selectedOption) => {
                  this.setState({
                    device: selectedOption,
                  });
                }}
                // for future development multiple brand device selection
                // formatLabel={(item) => {
                //   const brandName = this.state.selectedBrand?.label || "";
                //   return `${brandName ? `${brandName} - ` : ""}${item.name}`;
                // }}
                // isDisabled={!this.props.selectedbrandID}
              />
            </div>
            <div className={"single-warranty-details-item mb-3"}>
              <label
                className={"single-warranty-details-label required"}
                htmlFor="spare_part_name"
              >
                Part Name<span></span>
              </label>
              <input
                type="text"
                id="spare_part_name"
                //  pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                required={true}
                className="form-control"
                onChange={this.handleChange}
                value={this.state.spare_part_name}
              />
            </div>
            {this.props.isEdit && (
              <div className={"single-warranty-details-item mb-3"}>
                <label
                  className={"single-warranty-details-label"}
                  htmlFor="part_used"
                >
                  Part Used<span></span>
                </label>
                <input
                  type="number"
                  id="quantity"
                  disabled
                  className="form-control"
                  value={this.state.part_used}
                />
              </div>
            )}
          </div>
          <div className="card-footer ">
            <div className="d-flex justify-content-start gap-2">
              <button className="k-btn k-btn-primary ">Save</button>
              <button
                className="k-btn k-btn-outline-primary"
                onClick={this.props.handleCloseModal}
              >
                Close
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}
